import { axiosClient } from '../core/axiosClient';

const createFormData = <T extends Record<string, any>>(data: T): FormData => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") {
            // Skip null, undefined, or empty string values
            return;
        }

        if (key === 'files' && typeof value === 'object') {
            // Handle files dictionary: { filetype: File }
            Object.entries(value).forEach(([fileType, file]) => {
                if (file instanceof File) {
                    formData.append(`files.${fileType}`, file);
                }
            });
        } else if (value instanceof File) {
            // If it's a direct file (unlikely with your backend structure)
            formData.append(key, value);
        } else if (typeof value === 'object') {
            // Nested object values, stringify
            formData.append(key, JSON.stringify(value));
        } else {
            // Primitive types
            formData.append(key, value.toString());
        }
    });

    return formData;
};


export async function PostRequest<T = any>(
    action: string,
    body: any,
    timeout: number = 120000
): Promise<T> {
    try {
        const response = await axiosClient.post(action, body, {
            maxBodyLength: Infinity,
            timeout: timeout,
        });
        return response.data as T;
    } catch (error) {
        console.error('PostRequest error');
        throw error;
    }
}

export async function PostRequestFormData<T extends Record<string, any>, R = any>(action: string, data: T): Promise<R> {

    try {
        const formData = createFormData(data);
        const response = await axiosClient.post(action, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            maxBodyLength: Infinity,
        });
        return response?.data as R;
    } catch (error) {
        console.error('PostRequestFormData error');
        throw error;
    }
}